import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-vue-v3';
import { getFallbackDeviceId } from './deviceId';
class FingerPrint {
    deviceId = '';
    async update() {
        try {
            const { data, getData } = useVisitorData({ extendedResult: true }, { immediate: false });
            await getData();
            this.deviceId = data.value?.visitorId;
        }
        catch (e) {
            console.warn('fpjs failed, using fallback:', e);
            this.deviceId = getFallbackDeviceId();
        }
    }
    async get() {
        if (!this.deviceId) {
            await this.update();
        }
        return {
            deviceId: this.deviceId,
        };
    }
}
export default new FingerPrint();
